module.exports = __webpack_public_path__ + "img/banner_platform.74f1ce0e.png";